import {DeviceForSharingSortType} from '../../types/shared-devices.type';
import {OrderType} from '../../types/order.type';

export class FetchDevicesToShare {
  static readonly type = '[Share devices form] Fetch devices';

  constructor() {
  }
}

export class SetPageDevicesToShare {
  static readonly type = '[Share devices form] Set page devices to share';

  constructor(public page: number) {
  }
}

export class SearchDevicesToShare {
  static readonly type = '[Share devices form] Search devices to share';

  constructor(public search: string) {
  }
}

export class SetDeviceToShare {
  static readonly type = '[Share devices form] Set device id to share';

  constructor(public payload: { id: number, name?: string }) {
  }
}

export class UploadSharedDevicesPhotos {
  static readonly type = '[Share devices form] upload photos';

  constructor(public payload: { photos: string, id: number }) {
  }
}

export class GetSharedPhotosByDeviceId {
  static readonly type = '[Share devices form] get photos by device id';

  constructor(public deviceId: number) {
  }
}

export class GetSharedDeviceById {
  static readonly type = '[Share device form] get share device by id';

  constructor(public id: number) {
  }
}

export class EnableSliderLoader {
  static readonly type = '[Share device form] enable slider loader';
}

export class DisableSliderLoader {
  static readonly type = '[Share device form] disable slider loader';
}

export class ResetSharedFormState {
  static readonly type = '[Share device form] reset state';
}

export class SetMapCoordinates {
  static readonly type = '[Share device form] set map coordinates';

  constructor(public coordinates: {lat: number, long: number, address: string}) {
  }
}

export class SortDeviceToShare {
  static readonly type = '[Share device form] Sort devices for sharing';

  constructor(public payload: {
    sort: DeviceForSharingSortType,
    order: OrderType
  }) {
  }
}
